import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import { employeeJobTitle } from 'modules/contracts/lib/utils'
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import type JobLevel from 'modules/job_catalog/store/models/JobLevel'
import JobRole from 'modules/job_catalog/store/models/JobRole'

import { employeeJobLevel } from './levels'

class JobRoles extends Collection<JobRole> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      active: computed,
    })
  }

  get cacheKey(): string {
    return 'jobRoles'
  }

  model() {
    return JobRole
  }

  get active() {
    return this.filter({ archived: false })
  }
}

const singleton = new JobRoles()

export const jobLevelRole = (jobLevel: JobLevel) => {
  return singleton.get(jobLevel.attributes.role_id)
}

export const employeeJobRole = (contractVersions: ContractVersions, employee: Employee) => {
  return singleton.get(employeeJobLevel(contractVersions, employee)?.attributes.role_id)
}

/** Given the reference contract of an employee
 *  returns the job title and if is empty,
 *  return the job role + level if presents */
export const employeeJob = (contractVersions: ContractVersions, employee: Employee) => {
  const jobTitle = employeeJobTitle(contractVersions, employee)

  if (jobTitle) {
    return jobTitle
  }
  return employeeJobAndLevel(contractVersions, employee)
}

const employeeJobAndLevel = (contractVersions: ContractVersions, employee: Employee) => {
  const jobLevel = employeeJobLevel(contractVersions, employee)
  const jobRole = jobLevel ? jobLevelRole(jobLevel) : null

  const jobLevelName = !jobLevel || jobLevel?.isDefault ? '' : jobLevel?.attributes.name
  const jobRoleName = jobRole?.attributes.name || ''

  return jobRoleName && jobLevelName ? `${jobRoleName}, ${jobLevelName}` : jobRoleName
}

export default singleton
